(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mavisse-category-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (root) => root.querySelectorAll('.mv-mega:not([data-bound]), .mv-category-bar__info:not([data-bound])').forEach(menu => {
    menu.dataset.bound = 'true';
    const siblings = () => menu.closest('nav').querySelectorAll('.mv-mega, .mv-category-bar__info');
    const open = () => { siblings().forEach(other => { if(other !== menu) other.open = false; }); menu.open = true; };
    menu.addEventListener('pointerenter', event => { if(event.pointerType === 'mouse' && menu.classList.contains('mv-mega')) open(); });
    menu.addEventListener('pointerleave', event => { if(event.pointerType === 'mouse' && menu.classList.contains('mv-mega') && !menu.contains(document.activeElement)) menu.open = false; });
    menu.addEventListener('toggle', () => { if(menu.open) siblings().forEach(other => { if(other !== menu) other.open = false; }); });
    menu.addEventListener('focusout', event => { if(!menu.contains(event.relatedTarget)) menu.open = false; });
    menu.addEventListener('keydown', event => { if(event.key === 'Escape') { menu.querySelector('summary').focus(); menu.open = false; event.stopPropagation(); } });
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('click', event => document.querySelectorAll('.mv-mega[open], .mv-category-bar__info[open]').forEach(menu => { if(!menu.contains(event.target)) menu.open = false; }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mavisse-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  if(event.target.closest('[data-mv-back-top]')) window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mavisse-review-demo"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = root => root.querySelectorAll('[data-review-carousel]:not([data-bound])').forEach(carousel => {
    carousel.dataset.bound = 'true';
    const track = carousel.querySelector('.mv-review-demo__track');
    const prev = carousel.querySelector('[data-review-prev]');
    const next = carousel.querySelector('[data-review-next]');
    const update = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = direction => {
      const card = track.querySelector('article');
      if(!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
      track.scrollBy({left:direction * step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    track.addEventListener('keydown', event => {
      if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    const observer = new ResizeObserver(update); observer.observe(track);
    document.addEventListener('shopify:section:unload', event => { if(event.target.contains(carousel)) observer.disconnect(); });
    update();
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:block:select', event => {
    if(event.target.closest('[data-review-carousel]')) event.target.scrollIntoView({behavior:'auto',block:'nearest',inline:'nearest'});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mavisse-welcome-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-mv-welcome]').forEach(dialog => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const editor = dialog.dataset.editor === 'true';
    const dismissedKey = 'mavisse.welcome.dismissed';
    const subscribedKey = 'mavisse.welcome.subscribed';
    const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
    const write = (storage, key) => { try { window[storage].setItem(key, '1'); } catch {} };
    let previousFocus;
    const open = () => { if (!dialog.isConnected || dialog.open || (!editor && document.querySelector('[data-mv-cookies][open]'))) return; previousFocus = document.activeElement; dialog.showModal(); document.documentElement.classList.add('mv-welcome-lock'); };
    const close = () => {
      if (!dialog.open || dialog.hasAttribute('data-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !dialog.animate) { dialog.close(); return; }
      dialog.setAttribute('data-closing', '');
      const animation = dialog.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(10px)'}], {duration:300,easing:'ease-out',fill:'forwards'});
      const finish = () => { dialog.close(); animation.cancel(); dialog.removeAttribute('data-closing'); };
      animation.finished.then(finish, finish);
    };
    dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('mv-welcome-lock'); if (!editor) write('sessionStorage', dismissedKey); if (previousFocus?.isConnected) previousFocus.focus(); });
    const form = dialog.querySelector('form');
    const ownSubmission = location.hash === '#' + form.id;
    const success = dialog.querySelector('[data-welcome-success]');
    const error = dialog.querySelector('[data-welcome-error]');
    const afterPrivacy = () => {
      let scheduled = false;
      let complete = false;
      const privacyReady = () => {
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy || typeof privacy.currentVisitorConsent !== 'function' || typeof privacy.shouldShowBanner !== 'function') return false;
        try {
          const consent = privacy.currentVisitorConsent();
          const decided = ['analytics', 'marketing', 'preferences'].every(key => consent[key] === 'yes' || consent[key] === 'no');
          return decided || privacy.shouldShowBanner() === false;
        } catch { return false; }
      };
      const cookieDialogReady = () => {
        const cookies = document.querySelector('[data-mv-cookies]');
        return !cookies || (!cookies.open && ['ready', 'dismissed'].includes(cookies.dataset.consentState));
      };
      const ready = () => privacyReady() && cookieDialogReady();
      const check = () => {
        if (complete || scheduled || !dialog.isConnected || !ready()) return;
        scheduled = true;
        setTimeout(() => {
          scheduled = false;
          if (complete || !dialog.isConnected || !ready()) return;
          complete = true;
          document.removeEventListener('visitorConsentCollected', check);
          document.removeEventListener('mavisse:privacy-ready', check);
          open();
        }, ownSubmission ? 300 : 1000);
      };
      document.addEventListener('visitorConsentCollected', check);
      document.addEventListener('mavisse:privacy-ready', check);
      if (window.Shopify?.customerPrivacy) check();
      else if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
          if (!error) check();
        });
      }
    };
    if (!editor && success && ownSubmission) { write('localStorage', subscribedKey); write('sessionStorage', dismissedKey); afterPrivacy(); }
    else if (!editor && error && ownSubmission) afterPrivacy();
    else if (!editor && !success && !read('sessionStorage', dismissedKey) && !read('localStorage', subscribedKey)) afterPrivacy();
    document.addEventListener('shopify:section:select', event => { if (editor && event.detail.sectionId === dialog.dataset.section) open(); });
    document.addEventListener('shopify:section:deselect', event => { if (editor && event.detail.sectionId === dialog.dataset.section && dialog.open) close(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-banner"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-mv-cookies]').forEach(dialog => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const editor = dialog.dataset.editor === 'true';
    const error = dialog.querySelector('[data-cookie-error]');
    const loadError = dialog.querySelector('[data-cookie-load-error]');
    const choices = dialog.querySelectorAll('[data-cookie-choice]');
    let api, previousFocus, busy = false, finished = false;

    const signal = state => {
      dialog.dataset.consentState = state;
      document.dispatchEvent(new CustomEvent('mavisse:privacy-ready', {detail: {state}}));
    };
    const open = () => {
      if (dialog.open || !dialog.isConnected) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('mv-cookie-lock');
      signal('pending');
    };
    const finish = () => {
      if (finished) return;
      finished = true;
      if (dialog.open) dialog.close();
      signal('ready');
    };
    const setBusy = value => {
      busy = value;
      choices.forEach(button => button.disabled = value);
    };
    const load = () => new Promise((resolve, reject) => {
      let polling;
      const timeout = setTimeout(() => {
        clearInterval(polling);
        reject(new Error('Timeout'));
      }, 10000);
      const ready = () => {
        if (window.Shopify?.customerPrivacy) {
          clearTimeout(timeout);
          clearInterval(polling);
          resolve(window.Shopify.customerPrivacy);
          return;
        }
        if (!window.Shopify?.loadFeatures) return;
        clearInterval(polling);
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], failure => {
          clearTimeout(timeout);
          if (failure || !window.Shopify.customerPrivacy) reject(failure || new Error('Unavailable'));
          else resolve(window.Shopify.customerPrivacy);
        });
      };
      polling = setInterval(ready, 50);
      ready();
    });
    const dismiss = () => {
      if (busy) return;
      dialog.close();
      signal('dismissed');
    };
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('mv-cookie-lock');
      if (previousFocus?.isConnected) previousFocus.focus();
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    dialog.querySelector('[data-cookie-close]').addEventListener('click', dismiss);
    choices.forEach(button => button.addEventListener('click', async () => {
      if (busy) return;
      if (editor) { dialog.close(); return; }
      setBusy(true);
      error.hidden = true;
      loadError.hidden = true;
      try {
        api = api || await load();
        const value = button.dataset.cookieChoice === 'accept';
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => reject(new Error('Timeout')), 8000);
          api.setTrackingConsent({analytics: value, marketing: value, preferences: value}, result => {
            clearTimeout(timeout);
            if (result?.error) { reject(new Error(result.error)); return; }
            const saved = api.currentVisitorConsent();
            const expected = value ? 'yes' : 'no';
            if (['analytics', 'marketing', 'preferences'].every(key => saved[key] === expected)) resolve();
            else reject(new Error('Consent was not saved'));
          });
        });
        finished = false;
        finish();
      } catch {
        error.hidden = false;
      } finally {
        setBusy(false);
      }
    }));
    document.querySelectorAll('[data-cookie-settings]').forEach(button => button.addEventListener('click', () => {
      finished = false;
      open();
    }));
    document.addEventListener('visitorConsentCollected', () => {
      if (!busy && dialog.isConnected && !editor) { finished = false; finish(); }
    });
    document.addEventListener('shopify:section:select', event => {
      if (editor && event.detail.sectionId === dialog.dataset.section) open();
    });
    document.addEventListener('shopify:section:deselect', event => {
      if (editor && event.detail.sectionId === dialog.dataset.section) dialog.close();
    });
    if (!editor) {
      signal('pending');
      load().then(privacy => {
        api = privacy;
        const consent = api.currentVisitorConsent();
        const known = ['analytics', 'marketing', 'preferences'].every(key => consent[key] === 'yes' || consent[key] === 'no');
        if (known) finish();
        else open();
      }).catch(() => { open(); loadError.hidden = false; });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
